import React from 'react'
import ContactSection from '../ContactSection/Index'
import useTitle from '../../useTitle'
import '../OverMijPage/Styles.css';

const OverMij = () => {
    useTitle("Over Mij")
  return (
    <>
        {/* About Me Section */}
        <div className='aboutMeSection'>
            <div className='aboutMeInfoContainer'>

                <div className='aboutMeImageSection'>
                    <img src='/images/Agija-16-600.jpg' className='imageAboutMe' alt='yoga mindful breaks' srcSet="
                        /images/Agija-16-360.jpg 360w,
                        /images/Agija-16-600.jpg 600w,
                        /images/Agija-16-1200.jpg 1200w
                    "
                    sizes="(max-width: 768px) 360px, 600px" />
                </div>
                <div className='aboutMeDescriptionSection'>
                    <div className='aboutMeDescriptionTitle'>
                        <h1>Over Mij</h1>
                    </div>
                    <div className='aboutMeDescriptionText'>
                        <p>Ik ben Agija, de bezielster van Mindful Breaks. Beweging, gezondheid en bewust leven maken al mijn hele leven deel uit van wie ik ben. Ik groeide op in het platteland van Letland, dicht bij de natuur, altijd in beweging en omringd door puur en gezond eten.</p>
                        <br />
                        <p>Toen ik op mijn 22ste naar België verhuisde, verloor ik even mijn richting. Stap voor stap vond ik mezelf terug via sport, gezonde voeding en een actieve levensstijl. Maar pas toen ik yoga ontdekte, viel alles op zijn plaats. Yoga leerde me dat echte kracht niet alleen in je lichaam zit, maar ook in je rust, balans en verbinding met jezelf.</p>
                        <br />
                        <p>Met Mindful Breaks wil ik die ervaring doorgeven. Ik geloof dat iedereen baat heeft bij kleine, bewuste pauzes - momenten waarin je energie tankt, ontspanning vindt en meer balans brengt in je leven. Niet alleen op de yogamat, maar vooral daarbuiten.</p>
                        <br />
                        <p>Jij bent van harte welkom om samen met mij te ontdekken hoe yoga en Mindful Breaks ook jouw leven lichter, krachtiger en vrijer kunnen maken.</p>
                    </div>
                </div>
            </div>
        </div>
        <ContactSection />
    </>
  )
}

export default OverMij
